import {GoodsItem, GoodsSelection} from "../interfaces/GoodsInterface";

function daySpan(dateFrom?: string, dateTo?: string) {
	if (!dateFrom || !dateTo) return 1;
	const from = new Date(dateFrom);
	const to = new Date(dateTo);
	if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime()) || to <= from) return 1;
	return Math.max(1, Math.ceil((to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24)));
}

export function calculateGoodsTotal(goods: GoodsItem, selection: GoodsSelection) {
	const quantity = Math.max(1, selection.quantity || 1);
	const days = daySpan(selection.date_from, selection.date_to);
	const multiplier = goods.billing_type === "per_week"
		? Math.ceil(days / 7)
		: goods.billing_type === "per_day"
			? days
			: 1;

	return goods.price_gross * quantity * multiplier;
}

export function calculateGoodsVatAmount(goods: GoodsItem, selection: GoodsSelection) {
	const gross = Number(calculateGoodsTotal(goods, selection).toFixed(2));
	const taxRate = Number(goods.tax_rate ?? 0);

	if (!Number.isFinite(taxRate) || taxRate <= 0) return 0;

	const net = Number((gross / (1 + taxRate / 100)).toFixed(2));
	return Number((gross - net).toFixed(2));
}

export function calculateSelectedGoodsTotal(goodsItems: GoodsItem[], selections: GoodsSelection[]) {
	return selections.reduce((total, selection) => {
		const goods = goodsItems.find((item) => item.id === selection.goods_id);
		return goods ? total + calculateGoodsTotal(goods, selection) : total;
	}, 0);
}
